<template>
  <div class="market-toolbar" :class="{ 'search-active': isSearchOpen, 'search-selected': searchSelectedMode && !isSearchOpen }">

    <!-- Toolbar normale -->
    <div class="toolbar-content">

      <!-- Icona search -->
      <button v-if="showSearch" class="search-trigger-btn" @mousedown.prevent="openSearch" @touchend.prevent="openSearch">
        <v-icon color="#fff" size="20">mdi-magnify</v-icon>
      </button>

      <!-- Arrow left -->
      <button class="arrow left" @click="scroll(-1)" v-if="tabsScrollable && showLeftArrow">‹</button>

      <!-- Tabs scrollabili -->
      <div
          :class="['tab-scroll', tabsScrollable ? 'market-scroll' : 'market-nav-scroll']"
          ref="container"
          @scroll.passive="tabsScrollable ? moveIndicator : null"
      >
        <div v-if="tabsScrollable" class="tab-group-wrapper" :class="{ 'tab-group-wrapper--centered': centerTabs }">
          <button
              v-for="(group, index) in groups"
              :key="group._id"
              ref="tabs"
              :class="['btn-slide-market', { 'active-market': groupSelected === group._id }, smallLabel ? 'tab--small' : '']"
              @click="selectGroup(group, index)"
          >
            <img v-if="group.image" :src="group.image" class="tab-media tab-media--img" alt="" />
            <span v-else-if="group.svg" class="tab-media tab-media--svg" v-html="group.svg"></span>
            <v-icon v-else-if="group.icon" class="tab-media tab-media--icon" size="14">{{ group.icon }}</v-icon>
            <span class="text-market text-capitalize">{{ group.name || '' }}</span>
          </button>
          <div class="market-indicator" ref="indicator"></div>
        </div>
        <div v-else class="static-tab-container" ref="staticContainer">
          <div class="static-indicator" ref="staticIndicator"></div>
          <button
              v-for="group in groups"
              :key="group._id"
              class="p-button"
              :class="[{ 'static-tab--active': groupSelected === group._id }, smallLabel ? 'static-tab--small' : '']"
              @click="selectStaticGroup(group)"
          >
            <img v-if="group.image" :src="group.image" class="static-tab__img" alt="" />
            <span v-else-if="group.svg" class="static-tab__svg" v-html="group.svg"></span>
            <v-icon v-else-if="group.icon" class="static-tab__icon" size="14">{{ group.icon }}</v-icon>
            <span class="static-tab__label">{{ group.name || $t('all') || 'All' }}</span>
          </button>
        </div>
      </div>

      <!-- Arrow right -->
      <button class="arrow right" @click="scroll(1)" v-if="tabsScrollable && showRightArrow">›</button>

      <!-- Strumenti destra -->
      <div class="right-tools">

        <!-- Espandi/Comprimi -->
        <v-tooltip bottom content-class="custom-tooltip" v-if="showExpandCollapse">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon small class="mr-2 action-icon-btn"
                   v-bind="attrs" v-on="on"
                   @click="$emit('toggleExpansion')">
              <v-icon color="#aaa" size="22">
                {{ expansionOpened ? 'mdi-chevron-double-up' : 'mdi-chevron-double-down' }}
              </v-icon>
            </v-btn>
          </template>
          <span>{{ expansionOpened ? ($t('collapseAll') || 'Comprimi Tutti') : ($t('expandAll') || 'Espandi Tutti') }}</span>
        </v-tooltip>

        <!-- Cambio colonne -->
<!--        <v-tooltip v-if="showChangeCol && !isSmallScreen" bottom content-class="custom-tooltip">-->
<!--          <template v-slot:activator="{ on, attrs }">-->
<!--            <v-btn icon small class="mr-2 action-icon-btn"-->
<!--                   v-bind="attrs" v-on="on"-->
<!--                   @click="emitCol">-->
<!--              <svg style="height: 12px; width: auto" v-if="colToShow.length === 1" viewBox="19 19 38 38"><path fill="currentColor" d="M 19,19L 37,19L 37,27L 19,27L 19,19 Z M 39,19L 57,19L 57,23L 39,23L 39,19 Z M 19,29L 37,29L 37,33L 19,33L 19,29 Z M 39,25L 57,25L 57,29L 39,29L 39,25 Z M 19,35L 37,35L 37,39L 19,39L 19,35 Z M 39,31L 57,31L 57,39L 39,39L 39,31 Z M 19,41L 37,41L 37,45L 19,45L 19,41 Z M 39,41L 57,41L 57,45L 39,45L 39,41 Z M 19,47L 37,47L 37,51L 19,51L 19,47 Z M 39,47L 57,47L 57,51L 39,51L 39,47 Z M 19,53L 37,53L 37,57L 19,57L 19,53 Z M 39,53L 57,53L 57,57L 39,57L 39,53 Z"/></svg>-->
<!--              <svg style="height: 12px; width: auto" v-if="colToShow.length === 2" viewBox="19 19 38 38"><path fill="currentColor" d="M 19,19L 57,19L 57,27L 19,27L 19,19 Z M 19,29L 57,29L 57,33L 19,33L 19,29 Z M 19,35L 57,35L 57,39L 19,39L 19,35 Z M 19,41L 57,41L 57,45L 19,45L 19,41 Z M 19,47L 57,47L 57,51L 19,51L 19,47 Z M 19,53L 57,53L 57,57L 19,57L 19,53 Z"/></svg>-->
<!--            </v-btn>-->
<!--          </template>-->
<!--          <span>{{ colToShow.length === 1 ? $t('viewOn2row') : $t('viewOn1row') }}</span>-->
<!--        </v-tooltip>-->

      </div>
    </div>

    <!-- Search overlay: scivola da sinistra quando isSearchOpen -->
    <div class="search-overlay" v-if="showSearch">
      <button class="search-close-btn" @mousedown.prevent="closeSearch">
        <v-icon color="var(--text-platform)" size="20">mdi-close</v-icon>
      </button>
      <input
          type="text"
          ref="searchInput"
          v-model="searchQueryLocal"
          :placeholder="$t('searchMarkets') || 'Search Markets'"
          class="search-full-input"
      />
      <v-icon
          v-if="searchQueryLocal"
          small
          color="rgba(255,255,255,0.45)"
          @mousedown.prevent="clearSearch"
          class="cursor-pointer mr-1"
      >mdi-close</v-icon>
    </div>

  </div>
</template>

<script>
export default {
  name: 'SmartToolbar',
  props: {
    groups: { type: Array, default: () => [] },
    groupSelected: [String, Number],
    tabsScrollable: { type: Boolean, default: false },
    smallLabel: { type: Boolean, default: false },
    searchQuery: String,
    isSmallScreen: Boolean,
    showExpandCollapse: { type: Boolean, default: false },
    showChangeCol:      { type: Boolean, default: false },
    showSearch:         { type: Boolean, default: false },
    emitOnlyId:         { type: Boolean, default: true },
    expansionOpened: Boolean,
    colToShow: { type: Array, default: () => [0, 1] },
    centerTabs:         { type: Boolean, default: false }
  },
  data() {
    return {
      isSearchOpen: false,
      searchSelectedMode: false,
      searchQueryLocal: this.searchQuery || '',
      showLeftArrow: false,
      showRightArrow: false,
    };
  },
  watch: {
    searchQuery(newVal) {
      console.log('watch searchQuery', newVal );

      this.searchQueryLocal = newVal;
    },
    searchQueryLocal(newVal) {
      console.log('watch searchQueryLocal', newVal);
      this.$emit('update:searchQuery', newVal);
    },
    groupSelected() {
      if (this.tabsScrollable) this.$nextTick(this.moveIndicator);
      else this.$nextTick(this.moveStaticIndicator);
    },
    // Re-position the indicator when the groups list changes (e.g. favourites tab
    // appears/disappears), since groupSelected doesn't change in that case and
    // the DOM elements shift by one position.
    groups() {
      if (this.tabsScrollable) this.$nextTick(this.moveIndicator);
      else this.$nextTick(this.moveStaticIndicator);
    }
  },
  mounted() {
    if (!this.tabsScrollable) {
      this.$nextTick(this.moveStaticIndicator);
    }
    if (this.tabsScrollable) {
      this.$nextTick(() => {
        this.moveIndicator();
        this.updateArrows();
      });
      if (this.$refs.container) {
        this.$refs.container.addEventListener('scroll', this.updateArrows, { passive: true });
      }
      window.addEventListener('resize', this.onResize);
    }
    this._onClickOutside = (e) => {
      if (this.isSearchOpen && this.$el && !this.$el.contains(e.target)) {
        this.closeSearch();
      }
    };
    document.addEventListener('mousedown', this._onClickOutside);
  },
  beforeDestroy() {
    if (this.tabsScrollable && this.$refs.container) {
      this.$refs.container.removeEventListener('scroll', this.updateArrows);
    }
    if (this.tabsScrollable) {
      window.removeEventListener('resize', this.onResize);
    }
    document.removeEventListener('mousedown', this._onClickOutside);
  },
  methods: {
    emitCol() {
      this.$emit('changeCol', this.colToShow.length === 1 ? [0, 1] : [0]);
    },
    openSearch() {
      this.isSearchOpen = true;
      // Chiama focus subito (sincrono rispetto al gesture) per far aprire la tastiera su mobile,
      // poi $nextTick come fallback nel caso il ref non fosse ancora disponibile.
      if (this.$refs.searchInput) {
        this.$refs.searchInput.focus();
      } else {
        this.$nextTick(() => {
          if (this.$refs.searchInput) this.$refs.searchInput.focus();
        });
      }
    },
    closeSearch() {
      if (this.$refs.searchInput) this.$refs.searchInput.blur();
      this.isSearchOpen = false;
      this.searchQueryLocal = '';
    },
    clearSearch() {
      this.searchQueryLocal = '';
      if (this.$refs.searchInput) this.$refs.searchInput.focus();
    },
    selectGroup(group, index) {
      if (this.searchSelectedMode) this.$emit('exitSearchMode');
      this.searchSelectedMode = false;
      if (group._id !== this.groupSelected) {
        if (this.emitOnlyId)
          this.$emit('update:groupSelected', group._id);
        else
          this.$emit('update:groupSelected', group);
      }
      this.$nextTick(() => {

        const tab = this.$refs.tabs?.[index];
        const container = this.$refs.container;

        if (tab && container) {
          const scrollTarget = tab.offsetLeft - (container.clientWidth / 2) + (tab.offsetWidth / 2);
          container.scrollTo({ left: Math.max(0, scrollTarget), behavior: 'smooth' });
        }

        this.moveIndicator();
        this.updateArrows();
      });
    },
    scroll(direction) {
      if (!this.$refs.container) return;
      this.$refs.container.scrollBy({ left: direction * 150, behavior: 'smooth' });
      setTimeout(this.updateArrows, 220);
    },
    moveIndicator() {
      const indicator = this.$refs.indicator;
      const container = this.$refs.container;
      if (!indicator || !container) return;
      // Query the active tab directly by class — immune to $refs ordering issues
      // that can occur in Vue 2 when items are prepended to a v-for list.
      const tab = this.$el.querySelector('.btn-slide-market.active-market');
      if (!tab) return;
      indicator.style.width = `${tab.offsetWidth}px`;
      indicator.style.transform = `translateX(${tab.offsetLeft}px)`;
      this.updateArrows();
    },
    updateArrows() {
      this.$nextTick(() => {
        const container = this.$refs.container;
        if (!container) return;
        const { scrollWidth, clientWidth, scrollLeft } = container;
        if (scrollWidth <= clientWidth + 1) {
          this.showLeftArrow = false;
          this.showRightArrow = false;
          return;
        }
        this.showLeftArrow = scrollLeft > 4;
        this.showRightArrow = scrollLeft + clientWidth < scrollWidth - 4;
      });
    },
    onResize() {
      this.updateArrows();
    },
    selectStaticGroup(group) {
      this.searchSelectedMode = false;
      const payload = this.emitOnlyId ? group._id : group;
      this.$emit('update:groupSelected', payload);
      this.$emit('groupChange', payload);
      this.$nextTick(this.moveStaticIndicator);
    },
    moveStaticIndicator() {
      const indicator = this.$refs.staticIndicator;
      const container = this.$refs.staticContainer;
      if (!indicator || !container) return;
      const tab = container.querySelector('.p-button.static-tab--active');
      if (!tab) {
        indicator.style.opacity = '0';
        return;
      }
      indicator.style.opacity = '1';
      indicator.style.width = `${tab.offsetWidth}px`;
      indicator.style.height = `${tab.offsetHeight}px`;
      indicator.style.transform = `translate(${tab.offsetLeft}px, ${tab.offsetTop}px)`;
    },
    setSearchSelectedMode(val) {
      this.searchSelectedMode = !!val;
    }
  }
}
</script>

<style scoped>
.market-toolbar {
  display: flex;
  align-items: center;
  background: transparent;
  padding: 8px 0;
  position: relative;
  overflow: hidden;
  border-radius: 6px;
}

/* ── Toolbar content ── */
.toolbar-content {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  transition: opacity 0.22s ease, transform 0.25s ease;
}
.market-toolbar.search-active .toolbar-content {
  opacity: 0;
  pointer-events: none;
}

/* ── Search trigger icon ── */
.search-trigger-btn {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  border-radius: 4px;
  padding: 0;
  transition: background 0.15s;
  position: relative;
}

/* Indicatore sotto la lente quando searchSelectedMode è attivo */
.search-trigger-btn::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: var(--btn-background);
  opacity: 0;
  transition: opacity 0.25s ease;
}
.market-toolbar.search-selected .search-trigger-btn::after {
  opacity: 1;
}

/* ── Search overlay ── */
.search-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 6px 0 2px;
  opacity: 0;
  transform: translateX(-20px);
  pointer-events: none;
  transition: opacity 0.25s ease, transform 0.28s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.market-toolbar.search-active .search-overlay {
  opacity: 1;
  transform: translateX(0);
  pointer-events: auto;
}

.search-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  border-radius: 4px;
  padding: 0;
  transition: background 0.15s;
}

.search-full-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #fff;
  font-size: var(--font-size-3xl);
  padding: 3px 4px;
  min-width: 0;
  transition: border-color 0.2s;
}
.search-full-input::placeholder { color: rgba(255,255,255,0.32); font-size: var(--font-size-2xl); }

/* ── Tabs & scrollable ── */
.tab-scroll, .market-scroll, .market-nav-scroll {
  flex: 1;
  position: relative;
  overflow-x: auto;
  min-width: 0;
}
.market-scroll {
  display: flex;
  gap: 16px;
  scroll-behavior: smooth;
  scrollbar-width: none;
}
.market-scroll::-webkit-scrollbar { display: none; }
.tab-group-wrapper {
  display: flex;
  width: 100%;
  position: relative;
  gap: 16px;
}
.tab-group-wrapper--centered {
  justify-content: center;
}
.btn-slide-market {
  background: transparent;
  border: none;
  padding: 4px 0;
  color: var(--text-op-50-platform);
  cursor: pointer;
  white-space: nowrap;
  font-size: var(--font-size-7xl);
  display: inline-flex;
  align-items: center;
  gap: 5px;
  touch-action: manipulation;
  transition: color 0.2s;
}

.btn-slide-market.tab--small{
  font-size: var(--font-size-3xl) !important;

}
.tab-media--img {
  width: 16px;
  height: 16px;
  object-fit: contain;
  flex-shrink: 0;
}
.tab-media--icon {
  flex-shrink: 0;
  color: inherit !important;
}
.tab-media--svg {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
}
.btn-slide-market:active { opacity: 0.75; }
.btn-slide-market.active-market { color: var(--text-platform); font-weight: 700; }
.market-indicator {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 1px;
  background: var(--btn-background);
  transition: transform 0.3s, width 0.3s, opacity 0.25s ease;
  will-change: transform, width;
}
/* Nascondi indicatore tab e highlight quando search-selected */
.market-toolbar.search-selected .market-indicator {
  opacity: 0;
}
.market-toolbar.search-selected .btn-slide-market.active-market {
  color: var(--text-op-50-platform);
  font-weight: 400;
}

/* ── Arrows ── */
.arrow {
  background: none;
  border: none;
  color: var(--text-op-50-platform);
  font-size: var(--font-size-9xl);
  cursor: pointer;
  padding: 0 12px;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  touch-action: manipulation;
}
.arrow:hover { color: var(--text-platform); }
.arrow:active { opacity: 0.75; }

/* ── Static pill tabs (tabsScrollable = false) ── */

.market-nav-scroll {
  border-radius: 8px;
}
.static-tab-container {
  display: inline-flex;
  flex-wrap: nowrap;
  gap: 6px;
  padding: 3px 0;
  position: relative;
}

.static-indicator {
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 20px;
  background: var(--color-primary);
  pointer-events: none;
  opacity: 0;
  z-index: 0;
  transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1),
              width 0.28s cubic-bezier(0.4, 0, 0.2, 1),
              height 0.28s cubic-bezier(0.4, 0, 0.2, 1),
              opacity 0.2s ease;
}

.platform-button {
  position: relative;
  z-index: 1;
}
.market-nav-scroll {
  scrollbar-width: none;
}
.market-nav-scroll::-webkit-scrollbar { display: none; }
.static-tab {
  display: flex;
  align-items: center;
  gap: 5px;
  background: var(--event-background)!important;
  color: var(--text-op-50-platform);
  font-size: var(--font-size-xl);
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  touch-action: manipulation;

  column-gap: 10px;

  user-select: none;
  -webkit-tap-highlight-color: transparent;

  padding: 8px 14px;
  border-radius: 20px;

  background: var(--bg-cell);

  transition: all 0.2s ease;

}


.static-tab:hover { background: var(--bg-card-hover); color: var(--text-platform); }
.static-tab:active { opacity: 0.75; }

.static-tab__icon { flex-shrink: 0; }
.static-tab__label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  font-family: Roboto, sans-serif;
  font-weight: 500;

}

.static-tab__img {
  width: 16px;
  height: 16px;
  object-fit: contain;
  flex-shrink: 0;
}
.static-tab__svg {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
}


.static-tab--active .static-tab__img{
  filter: brightness(0) ;
}




/* ── Right tools ── */
.right-tools { display: flex; align-items: center; gap: 2px; }
.action-icon-btn:hover { background: rgba(255, 255, 255, 0.1); }
.action-icon-btn { color: var(--text-op-50-platform)!important; }

@media (max-width: 600px) {
  .btn-slide-market { min-height: 30px; font-size: var(--font-size-4xl); padding: 0; }
  .static-tab { min-height: 36px; font-size: var(--font-size-3xl); padding: 4px 12px; }
  .arrow { min-height: 44px; min-width: 40px; padding: 0 8px; display: none }
  .market-toolbar { padding: 6px 0px; }
}

.p-button{
  border: 1px solid hsla(0, 0%, 100%, 0);
  border-radius: 50px;
  place-content: center;
  transition: all .25s;
  color: #fff;
  cursor: pointer;
  font-weight: 700;
  white-space: nowrap;
  font-size: var(--font-size-3xl);
  height: 32px;
  padding: 0 8px;
  text-transform: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  transition: all .25s;
  z-index: 1;
}
</style>
